// src/processors/resource/resource-url-processor.ts - Resource URL Processing
import { XConVitePluginOptions } from '../../types';
import {Logger} from "../../utils/logger";
/**
 * Handles resource URL processing, normalization, and base URL application
 */
export class ResourceUrlProcessor {
    constructor(
        private options: Required<XConVitePluginOptions>,
        private logger: Logger
    ) {}

    /**
     * Process resource URL with base URL application
     */
    processResourceUrl(resource: any): any {
        const processedResource = { ...resource };

        if (this.shouldApplyBaseUrl(resource.url)) {
            processedResource.url = this.applyBaseUrl(resource.url);
        }

        return processedResource;
    }

    /**
     * Check if base URL should be applied
     */
    private shouldApplyBaseUrl(url: string): boolean {
        return Boolean(this.options.resourceBaseUrl) &&
            Boolean(url) &&
            !this.isAbsoluteUrl(url);
    }

    /**
     * Apply base URL to resource URL
     */
    private applyBaseUrl(url: string): string {
        const baseUrl = this.options.resourceBaseUrl.replace(/\/$/, '');
        const resourceUrl = url.replace(/^\//, '');
        return `${baseUrl}/${resourceUrl}`;
    }

    /**
     * Check if URL is absolute
     */
    isAbsoluteUrl(url: string): boolean {
        return /^https?:\/\//.test(url) || /^\/\//.test(url) || url.startsWith('/');
    }
}